import { IColunaExtracao } from "../../../application/models";

export const velesGeoColunasPadraoExtracao: IColunaExtracao[] = [
    {
        label: 'CPF',
        value: 'cpf'
    },
    {
        label: 'Nome Completo',
        value: 'nome'
    },
    {
        label: 'Sexo',
        value: 'sexo'
    },
    {
        label: 'Data de Nascimento',
        value: 'datanascimento'
    },
    {
        label: 'Idade',
        value: 'idade'
    },
    {
        label: 'Endereço Completo',
        value: 'enderecocompleto'
    },
    {
        label: 'Endereço - Tipo',
        value: 'enderecotipo'
    },
    {
        label: 'Endereço - Título',
        value: 'enderecotitulo'
    },
    {
        label: 'Endereço - Logradouro',
        value: 'enderecologradouro'
    },
    {
        label: 'Número',
        value: 'endereconumero'
    },
    {
        label: 'Complemento',
        value: 'enderecocomplemento'
    },
    {
        label: 'Bairro',
        value: 'bairro'
    },
    {
        label: 'CEP',
        value: 'cep'
    },
    {
        label: 'Cidade',
        value: 'cidade'
    },
    {
        label: 'UF',
        value: 'uf'
    },
    {
        label: 'Microrregião',
        value: 'microrregiao'
    },
    {
        label: 'Mesorregião',
        value: 'mesorregiao'
    },
    {
        label: 'Macrorregião',
        value: 'macrorregiao'
    },
    {
        label: 'Celular 1 - DDD',
        value: 'celularddd1'
    },
    {
        label: 'Celular 1 - Número',
        value: 'celulartelefone1'
    },
    {
        label: 'Celular 1 - WhatsApp',
        value: 'celularwhatsapp1'
    },
    // {
    //     label: 'Celular 1 - Procon',
    //     value: 'celularprocon1'
    // },
    {
        label: 'Celular 2 - DDD',
        value: 'celularddd2'
    },
    {
        label: 'Celular 2 - Número',
        value: 'celulartelefone2'
    },
    {
        label: 'Celular 2 - WhatsApp',
        value: 'celularwhatsapp2'
    },
    // {
    //     label: 'Celular 2 - Procon',
    //     value: 'celularprocon2'
    // },
    {
        label: 'Celular 3 - DDD',
        value: 'celularddd3'
    },
    {
        label: 'Celular 3 - Número',
        value: 'celulartelefone3'
    },
    {
        label: 'Celular 3 - WhatsApp',
        value: 'celularwhatsapp3'
    },
    // {
    //     label: 'Celular 3 - Procon',
    //     value: 'celularprocon3'
    // },
    {
        label: 'Celular 4 - DDD',
        value: 'celularddd4'
    },
    {
        label: 'Celular 4 - Número',
        value: 'celulartelefone4'
    },
    {
        label: 'Celular 4 - WhatsApp',
        value: 'celularwhatsapp4'
    },
    // {
    //     label: 'Celular 4 - Procon',
    //     value: 'celularprocon4'
    // },
    {
        label: 'Celular 5 - DDD',
        value: 'celularddd5'
    },
    {
        label: 'Celular 5 - Número',
        value: 'celulartelefone5'
    },
    {
        label: 'Celular 5 - WhatsApp',
        value: 'celularwhatsapp5'
    },
    // {
    //     label: 'Celular 5 - Procon',
    //     value: 'celularprocon5'
    // },
    {
        label: 'Celular 6 - DDD',
        value: 'celularddd6'
    },
    {
        label: 'Celular 6 - Número',
        value: 'celulartelefone6'
    },
    {
        label: 'Celular 6 - WhatsApp',
        value: 'celularwhatsapp6'
    },
    // {
    //     label: 'Celular 6 - Procon',
    //     value: 'celularprocon6'
    // },
    {
        label: 'Celular 7 - DDD',
        value: 'celularddd7'
    },
    {
        label: 'Celular 7 - Número',
        value: 'celulartelefone7'
    },
    {
        label: 'Celular 7 - WhatsApp',
        value: 'celularwhatsapp7'
    },
    // {
    //     label: 'Celular 7 - Procon',
    //     value: 'celularprocon7'
    // },
    {
        label: 'Celular 8 - DDD',
        value: 'celularddd8'
    },
    {
        label: 'Celular 8 - Número',
        value: 'celulartelefone8'
    },
    {
        label: 'Celular 8 - WhatsApp',
        value: 'celularwhatsapp8'
    },
    // {
    //     label: 'Celular 8 - Procon',
    //     value: 'celularprocon8'
    // },
    {
        label: 'Celular 9 - DDD',
        value: 'celularddd9'
    },
    {
        label: 'Celular 9 - Número',
        value: 'celulartelefone9'
    },
    {
        label: 'Celular 9 - WhatsApp',
        value: 'celularwhatsapp9'
    },
    // {
    //     label: 'Celular 9 - Procon',
    //     value: 'celularprocon9'
    // },
    {
        label: 'Celular 10 - DDD',
        value: 'celularddd10'
    },
    {
        label: 'Celular 10 - Número',
        value: 'celulartelefone10'
    },
    {
        label: 'Celular 10 - WhatsApp',
        value: 'celularwhatsapp10'
    },
    // {
    //     label: 'Celular 10 - Procon',
    //     value: 'celularprocon10'
    // },
    {
        label: 'Telefone Fixo 1 - DDD',
        value: 'fixoddd1'
    },
    {
        label: 'Telefone Fixo 1 - Número',
        value: 'fixotelefone1'
    },
    // {
    //     label: 'Telefone Fixo 1 - WhatsApp',
    //     value: 'fixowhatsapp1'
    // },
    // {
    //     label: 'Telefone Fixo 1 - Procon',
    //     value: 'fixoprocon1'
    // },
    {
        label: 'Telefone Fixo 2 - DDD',
        value: 'fixoddd2'
    },
    {
        label: 'Telefone Fixo 2 - Número',
        value: 'fixotelefone2'
    },
    // {
    //     label: 'Telefone Fixo 2 - WhatsApp',
    //     value: 'fixowhatsapp2'
    // },
    // {
    //     label: 'Telefone Fixo 2 - Procon',
    //     value: 'fixoprocon2'
    // },
    {
        label: 'Telefone Fixo 3 - DDD',
        value: 'fixoddd3'
    },
    {
        label: 'Telefone Fixo 3 - Número',
        value: 'fixotelefone3'
    },
    // {
    //     label: 'Telefone Fixo 3 - WhatsApp',
    //     value: 'fixowhatsapp3'
    // },
    // {
    //     label: 'Telefone Fixo 3 - Procon',
    //     value: 'fixoprocon3'
    // },
    {
        label: 'Telefone Fixo 4 - DDD',
        value: 'fixoddd4'
    },
    {
        label: 'Telefone Fixo 4 - Número',
        value: 'fixotelefone4'
    },
    // {
    //     label: 'Telefone Fixo 4 - WhatsApp',
    //     value: 'fixowhatsapp4'
    // },
    // {
    //     label: 'Telefone Fixo 4 - Procon',
    //     value: 'fixoprocon4'
    // },
    {
        label: 'Telefone Fixo 5 - DDD',
        value: 'fixoddd5'
    },
    {
        label: 'Telefone Fixo 5 - Número',
        value: 'fixotelefone5'
    },
    // {
    //     label: 'Telefone Fixo 5 - WhatsApp',
    //     value: 'fixowhatsapp5'
    // },
    // {
    //     label: 'Telefone Fixo 5 - Procon',
    //     value: 'fixoprocon5'
    // },
    {
        label: 'Telefone Fixo 6 - DDD',
        value: 'fixoddd6'
    },
    {
        label: 'Telefone Fixo 6 - Número',
        value: 'fixotelefone6'
    },
    // {
    //     label: 'Telefone Fixo 6 - WhatsApp',
    //     value: 'fixowhatsapp6'
    // },
    // {
    //     label: 'Telefone Fixo 6 - Procon',
    //     value: 'fixoprocon6'
    // },
    {
        label: 'Telefone Fixo 7 - DDD',
        value: 'fixoddd7'
    },
    {
        label: 'Telefone Fixo 7 - Número',
        value: 'fixotelefone7'
    },
    // {
    //     label: 'Telefone Fixo 7 - WhatsApp',
    //     value: 'fixowhatsapp7'
    // },
    // {
    //     label: 'Telefone Fixo 7 - Procon',
    //     value: 'fixoprocon7'
    // },
    {
        label: 'Telefone Fixo 8 - DDD',
        value: 'fixoddd8'
    },
    {
        label: 'Telefone Fixo 8 - Número',
        value: 'fixotelefone8'
    },
    // {
    //     label: 'Telefone Fixo 8 - WhatsApp',
    //     value: 'fixowhatsapp8'
    // },
    // {
    //     label: 'Telefone Fixo 8 - Procon',
    //     value: 'fixoprocon8'
    // },
    {
        label: 'Telefone Fixo 9 - DDD',
        value: 'fixoddd9'
    },
    {
        label: 'Telefone Fixo 9 - Número',
        value: 'fixotelefone9'
    },
    // {
    //     label: 'Telefone Fixo 9 - WhatsApp',
    //     value: 'fixowhatsapp9'
    // },
    // {
    //     label: 'Telefone Fixo 9 - Procon',
    //     value: 'fixoprocon9'
    // },
    {
        label: 'Telefone Fixo 10 - DDD',
        value: 'fixoddd10'
    },
    {
        label: 'Telefone Fixo 10 - Número',
        value: 'fixotelefone10'
    },
    // {
    //     label: 'Telefone Fixo 10 - WhatsApp',
    //     value: 'fixowhatsapp10'
    // },
    // {
    //     label: 'Telefone Fixo 10 - Procon',
    //     value: 'fixoprocon10'
    // },
    {
        label: 'E-mail 1',
        value: 'email1'
    },
    {
        label: 'E-mail 2',
        value: 'email2'
    },
    {
        label: 'E-mail 3',
        value: 'email3'
    },
    // {
    //     label: 'E-mail 4',
    //     value: 'email4'
    // },
    // {
    //     label: 'E-mail 5',
    //     value: 'email5'
    // },
    // {
    //     label: 'E-mail 6',
    //     value: 'email6'
    // },
    // {
    //     label: 'E-mail 7',
    //     value: 'email7'
    // },
    // {
    //     label: 'E-mail 8',
    //     value: 'email8'
    // },
    // {
    //     label: 'E-mail 9',
    //     value: 'email9'
    // },
    // {
    //     label: 'E-mail 10',
    //     value: 'email10'
    // },
    // {
    //     label: 'Empresário',
    //     value: 'empresario'
    // },
    {
        label: 'Classe Social',
        value: 'classesocial'
    },
    {
        label: 'Escolaridade',
        value: 'escolaridade'
    },
    {
        label: 'Estado Civil',
        value: 'estadocivil'
    },
    {
        label: 'CBO',
        value: 'cbo'
    },
    {
        label: 'Ocupação',
        value: 'cbodescricao'
    },
    // {
    //     label: 'Nome da Mãe',
    //     value: 'nomemae'
    // },
    // {
    //     label: 'Nome do Pai',
    //     value: 'nomepai'
    // },
    // {
    //     label: 'Titular Falecido',
    //     value: 'obito'
    // },
    // {
    //     label: 'Possui E-mail',
    //     value: 'pessoafisicacomemail'
    // },
    // {
    //     label: 'Possui Endereço',
    //     value: 'pessoafisicacomendereco'
    // },
    // {
    //     label: 'Possui Procon',
    //     value: 'pessoafisicacomprocon'
    // },
    // {
    //     label: 'Possui Telefone',
    //     value: 'pessoafisicacomtelefone'
    // },
    // {
    //     label: 'Possui Celular',
    //     value: 'pessoafisicacomtelefonecelular'
    // },
    // {
    //     label: 'Possui Telefone Fixo',
    //     value: 'pessoafisicacomtelefonefixo'
    // },
    // {
    //     label: 'Possui WhatsApp',
    //     value: 'pessoafisicacomwhatsapp'
    // },
    // {
    //     label: 'PEP',
    //     value: 'pessoarestrita'
    // },
    {
        label: 'Renda Presumida Anual',
        value: 'rendapresumidaanual'
    },
    {
        label: 'Renda Presumida Mensal',
        value: 'rendapresumidamensal'
    },
    // {
    //     label: 'Score de Crédito',
    //     value: 'scorecredito'
    // },
    {
        label: 'Score de Crédito - Descrição',
        value: 'scorecreditodescricao'
    },
    {
        label: 'Signo',
        value: 'signo'
    },
    {
        label: 'Situação cadastral',
        value: 'situacaocadastral'
    },
    // {
    //     label: 'Situação Cadastral',
    //     value: 'situacaoCadastral'
    // }
]

export const velesGeoColunasLayoutPadrao: IColunaExtracao[] = [
    {
        label: 'CPF',
        value: 'cpf'
    },
    {
        label: 'Nome',
        value: 'nome'
    },
    {
        label: 'Data de Nascimento',
        value: 'datanascimento'
    },
    {
        label: 'Idade',
        value: 'idade'
    },
    {
        label: 'Sexo',
        value: 'sexo'
    },
    {
        label: 'Renda Presumida Anual',
        value: 'rendapresumidaanual'
    },
    {
        label: 'Classe Social',
        value: 'classesocial'
    },
    {
        label: 'Endereço',
        value: 'enderecocompleto'
    },
    {
        label: 'Endereço - Tipo',
        value: 'enderecotipo'
    },
    {
        label: 'Endereço - Titulo',
        value: 'enderecotitulo'
    },
    {
        label: 'Endereço - Logradouro',
        value: 'enderecologradouro'
    },
    {
        label: 'Número',
        value: 'endereconumero'
    },
    {
        label: 'Complemento',
        value: 'enderecocomplemento'
    },
    {
        label: 'Bairro',
        value: 'bairro'
    },
    {
        label: 'Cidade',
        value: 'cidade'
    },
    {
        label: 'UF',
        value: 'uf'
    },
    {
        label: 'CEP',
        value: 'cep'
    },
    {
        label: 'Celular 1 - DDD',
        value: 'celularddd1'
    },
    {
        label: 'Celular 1 - Telefone',
        value: 'celulartelefone1'
    },
    {
        label: 'Celular 1 - WhatsApp',
        value: 'celularwhatsapp1'
    },
    {
        label: 'Celular 2 - DDD',
        value: 'celularddd2'
    },
    {
        label: 'Celular 2 - Telefone',
        value: 'celulartelefone2'
    },
    {
        label: 'Celular 2 - WhatsApp',
        value: 'celularwhatsapp2'
    },
    {
        label: 'Celular 3 - DDD',
        value: 'celularddd3'
    },
    {
        label: 'Celular 3 - Telefone',
        value: 'celulartelefone3'
    },
    {
        label: 'Celular 3 - WhatsApp',
        value: 'celularwhatsapp3'
    },
    {
        label: 'Telefone Fixo 1 - DDD',
        value: 'fixoddd1'
    },
    {
        label: 'Telefone Fixo 1 - Número',
        value: 'fixotelefone1'
    },
    {
        label: 'E-mail 1',
        value: 'email1'
    },
    {
        label: 'E-mail 2',
        value: 'email2'
    }
]